module.exports = __webpack_public_path__ + "static/media/UpgradeDialer.ea1b6a53.png";